/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：27
 */

"use strict"

function r(e, t) {
  if (!(e instanceof t)) {
    throw new TypeError("Cannot call a class as a function")
  }
}
export { r as a }
export default r
